import React from "react";
import { useTranslation } from "react-i18next";

import betwayScoresLogo from "../../assets/betway-scores.svg";
import styles from "./AccessDenied.module.css";
import "../../utils/externalUrlHandler";

const AccessDenied = () => {
	const { t } = useTranslation();

	const handleDownloadApp = () => {
		// You can customize these URLs based on the actual app store links
		const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
		const isAndroid = /Android/.test(navigator.userAgent);

		let appUrl;
		if (isIOS) {
			appUrl = "https://apps.apple.com/bg/app/betway-scores-football-news/id1552348455";
		} else if (isAndroid) {
			appUrl = "https://play.google.com/store/apps/details?id=com.betway.scores.android"; // Replace with actual Google Play link
		} else {
			// Fallback for desktop or other devices
			appUrl = "https://betwayscores.com";
		}

		// Use global helper to open app store URL
		window.openAppStoreUrl(appUrl);
	};

	return (
		<div className={styles.container}>
			<div className={styles.card}>
				<div className={styles.logoContainer}>
					<img src={betwayScoresLogo} alt="Betway" className={styles.logo} />
				</div>

				<h2 className={styles.title}>{t("common.accessDenied.title")}</h2>

				<div className={styles.content}>
					<p className={styles.description}>{t("common.accessDenied.description")}</p>

					<p className={styles.rulesText}>{t("common.accessDenied.rulesText")}</p>
				</div>

				<div className={styles.buttonContainer}>
					<button className={styles.downloadButton} onClick={handleDownloadApp}>
						{t("common.accessDenied.button")}
					</button>
				</div>
			</div>
		</div>
	);
};

export default AccessDenied;
